import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { trTR } from "@clerk/localizations/tr-TR";

// Brand Clerk here once: it styles sign-in, sign-up and the user menu.
const appearance = {
  variables: {
    colorPrimary: "#2A1D16",
    colorPrimaryForeground: "#F0E4B0",
    colorBackground: "#FFFFFF",
    colorForeground: "#2A1D16",
    fontFamily: "Outfit, system-ui, sans-serif",
    borderRadius: "0.75rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = "clerk_cfg_v1";
const cachedConfig = () => {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { return null; }
};
const firstFetch = fetch(`${BACKEND_URL}/api/clerk/config`).then((r) => r.json()).catch(() => null);

// Starts Clerk from the backend's runtime config, so deploy's live keys need no rebuild.
// Must render inside <BrowserRouter> (see step 3) so Clerk navigates without reloading.
export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(cachedConfig);
  const [unavailable, setUnavailable] = useState(false);

  // Retries while the backend restarts (e.g. right after provisioning): the app's
  // Clerk components crash if they ever render without <ClerkProvider>.
  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = attempt === 0 ? await firstFetch : await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg?.enabled) {
          localStorage.setItem(CACHE_KEY, JSON.stringify(cfg));
          return cancelled || setConfig((old) => (old?.publishable_key === cfg.publishable_key && old?.proxy_url === cfg.proxy_url ? old : cfg));
        }
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Giriş hizmeti şu anda kullanılamıyor. Lütfen sayfayı yenileyin.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={trTR}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
